import { render, staticRenderFns } from "./SubmissionItem.vue?vue&type=template&id=9bf62ce2&scoped=true&"
import script from "./SubmissionItem.vue?vue&type=script&lang=ts&"
export * from "./SubmissionItem.vue?vue&type=script&lang=ts&"
import style0 from "./SubmissionItem.vue?vue&type=style&index=0&id=9bf62ce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf62ce2",
  null
  
)

export default component.exports